var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32179 15.3392C5.32163 15.221 5.34478 15.1038 5.38991 14.9945C5.43503 14.8852 5.50126 14.7859 5.58479 14.7022L12.0248 8.26321C12.1935 8.09467 12.4223 8 12.6608 8C12.8993 8 13.128 8.09467 13.2968 8.26321L19.7368 14.7022C19.9056 14.8714 20.0003 15.1008 20 15.3398C19.9997 15.5788 19.9045 15.8079 19.7353 15.9767C19.5661 16.1455 19.3367 16.2402 19.0977 16.2399C18.8587 16.2396 18.6296 16.1444 18.4608 15.9752L12.6608 10.1752L6.86079 15.9752C6.73493 16.1009 6.57463 16.1865 6.40015 16.2212C6.22568 16.2558 6.04484 16.238 5.88048 16.17C5.71613 16.1019 5.57562 15.9867 5.47672 15.8388C5.37782 15.6909 5.32495 15.5171 5.32479 15.3392L5.32179 15.3392Z",
    fill: "#596975"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.7beccc23.svg";
export { ForwardRef as ReactComponent };